module.exports = __webpack_public_path__ + "media/images/back-8579ff4f42334578779c789ea6cb5816.png";